export default __webpack_public_path__ + "static/pin-0724929b05350befe310998dd87ee8c3.png";